module.exports = __webpack_public_path__ + "static/media/poke.c07ac470.pdf";